var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "profile-field__title",
        class: {
          "profile-field__title--required": _vm.field.required,
        },
      },
      [_vm._v(" Дополнительный номер телефона (родственника, знакомого) ")]
    ),
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "div",
        { staticClass: "phone" },
        [
          _c("c-input", {
            attrs: {
              label: "Номер телефона",
              clearable: true,
              placeholder: "+7 (___) ___ ____",
              mask: "+7 (###) ### ####",
              required: _vm.error && _vm.error.phone,
              "required-message": _vm.error && _vm.error.phone,
            },
            model: {
              value: _vm.phone,
              callback: function ($$v) {
                _vm.phone = $$v
              },
              expression: "phone",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "name" },
        [
          _c("c-input", {
            attrs: {
              "floating-label": "ФИО",
              clearable: true,
              "max-length": 255,
              required: _vm.error && _vm.error.name,
              "required-message": _vm.error && _vm.error.name,
            },
            model: {
              value: _vm.name,
              callback: function ($$v) {
                _vm.name = $$v
              },
              expression: "name",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "status" },
        [
          _c("c-select", {
            attrs: {
              type: "select",
              "floating-label": "Кем приходится",
              items: _vm.options,
              clearable: true,
              searchable: true,
              "custom-options": _vm.field.custom,
              invalid: !!(_vm.error && _vm.error.status),
              error: _vm.error && _vm.error.status,
            },
            model: {
              value: _vm.status,
              callback: function ($$v) {
                _vm.status = $$v
              },
              expression: "status",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }